import { Mittelgeber } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Mittelgeber')

export default {
  label: 'Mittelgeber',
  route: 'mittelgeber',
  class: Mittelgeber,
  className: 'mittelgeber',
  fields: [
    {
      ...Fields.String('name'),
      table: true
    },
    Fields.String('finSchluessel')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Mittelgeber.js